"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/**
 * Obtiene la prescripción de events/prescriptions
 * @param id id de la prescripción
 * @returns
 */
function usePrescription(firestore, prescriptionData, firestoreHookOption, queryOptions) {
    const prescriptionsRef = (0, firestore_2.doc)(firestore, `events/prescriptions/${prescriptionData.country}/${prescriptionData.id}`);
    return (0, firestore_1.useFirestoreDocument)(keyFactory_1.FirestoreKeys.Prescriptions({
        name: "eventPrescription",
        path: `events/prescriptions/${prescriptionData.country}/${prescriptionData.id}`
    }, [prescriptionData.country, prescriptionData.id]), prescriptionsRef, firestoreHookOption, {
        ...queryOptions,
        select: (prescription) => {
            const prescriptionData = {
                ...prescription.data(),
                id: prescription.id
            };
            return queryOptions?.select ? queryOptions.select(prescriptionData) : prescriptionData;
        }
    });
}
exports.default = usePrescription;
